/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LocalRoutes } from '../../local-routes';
import { httpStatus } from './http-status';

@Injectable()
export class HttpInterceptorHandleErrors implements HttpInterceptor {
	private router = inject(Router);

	apiUrl: string;

	constructor() {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				console.error(request?.url, error);

				if (error.status === httpStatus.UNAUTHORIZED_401) {
					this.router.navigateByUrl(LocalRoutes.LOGIN);
				}

				return throwError(error);
			})
		);
	}
}
